<div class="modal-header">
  <h5 class="modal-title" id="profile-title">
    <p>Choose a company to view report.</p>
  </h5>
</div>
@if (!loading) {
  <ul class="list-group">
    @for (item of companies; track item) {
      <li class="list-group-item" (click)="pick(item)" [class.active]="item === selection">
        {{ item.customerName }}
      </li>
    }
  </ul>
}
@if (loading) {
  <app-spinner></app-spinner>
}
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="select()" [disabled]="selection === null || loading">
    Select
  </button>
</div>
